// auto generated code
import './base-components/array-base/style.less'
import './base-components/cascade-picker/style.less'
import './base-components/check-list/style.less'
import './base-components/checkbox/style.less'
import './base-components/date-picker/style.less'
import './base-components/form-button-group/style.less'
import './base-components/form-item/style.less'
import './base-components/list/style.less'
import './base-components/radio/style.less'
import './biz-components/style.less'
